import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import ProjectCard from "./ProjectCards";
import Particle from "../Particle";
import join from "../../Assets/Projects/join.png";
import ultimate from "../../Assets/Projects/ultimate.png";
import plumbing from "../../Assets/Projects/plumbing.png";
import myeasybooks from "../../Assets/Projects/myeasybooks.png";
import tredplus from "../../Assets/Projects/tredplus.png";
import helptag365 from "../../Assets/Projects/helptag365.png";

function Projects() {
  return (
    <Container fluid className="project-section">
      <Particle />
      <Container>
        <h1 className="project-heading">
          My Recent <strong className="purple">Works </strong>
        </h1>
        <p style={{ color: "white" }}>
          Here are some of the recent projects I've worked on.
        </p>
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={join}
              isBlog={false}
              title="Join Inc."
              description="A professional networking platform designed to help individuals connect, collaborate, and grow their network efficiently."
              demoLink="https://join.inc/"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={ultimate}
              isBlog={false}
              title="Ultimate Connector"
              description="A powerful platform enabling seamless B2B and B2C connections with robust communication features."
              demoLink="http://ultimateconnector.com/"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={plumbing}
              isBlog={false}
              title="NZ Plumbing"
              description="A modern website for a New Zealand-based plumbing service, providing online booking and service management."
              demoLink="https://www.nzplumbing.nz/"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={myeasybooks}
              isBlog={false}
              title="My Easy Books"
              description="An online accounting and bookkeeping solution designed for easy financial management and reporting."
              demoLink="https://myeasybooks.in/"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={tredplus}
              isBlog={false}
              title="TredPlus"
              description="Find thousands of investors near you! Tred+ helps you connect with investors actively looking for new opportunities. 
              Explore detailed profiles, understand their preferences, and make meaningful connections. 
              Tred+ empowers you to meet, grow, and maintain your cash flow effectively."
              demoLink="https://tredplus.com/"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={helptag365}
              isBlog={false}
              title="HelpTag365"
              description="An emergency assistance platform for vehicles, providing quick support for roadside issues like breakdowns, towing, and fuel delivery."
              demoLink="https://helptag365.in/"
            />
          </Col>

        </Row>
      </Container>
    </Container>
  );
}

export default Projects;
